/**
 * SpecialDayFetcher
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { Fetcher } from '../../fetchers/fetcher';

export class SpecialDayFetcher extends Fetcher {
    get modelName() {
        return 'Special Day';
    }

    get resourceName() {
        return 'special-days';
    }
}

export function specialDayFetcherProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(SpecialDayFetcher);
    }
}
